import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import bubble from "../../../images/Login/bubble-anmelden.png";
import "./LoginBubble.scss";

function LoginBubble() {
  const { i18n, t } = useTranslation(["login"]);

  return (
    <section id="LoginBubble">
      <div className="d-flex flex-column justify-content-center align-items-center mt-xxl-5">
        <div className="image-wrapper">
          <img src={bubble} alt="" />
        </div>
        <div className="rotate">
          <div className="text-wrapper">
            <h2>{t("bubble.text_1")}</h2>
            <h1>{t("bubble.text_2")}</h1>
            <h3>{t("bubble.text_3")}</h3>
            <div className="verticallyAligned">
              <FontAwesomeIcon color="red" icon={faChevronRight} style={{ marginRight: "8px" }} />
              <h4>{t("bubble.text_4")}</h4>
            </div>
            <h4>{t("bubble.text_5")}</h4>
            <h4 className="spacer">{t("bubble.text_6")}</h4>
            {/* <a className="link" href="https://www.ischebeck.de/">
              <p>{t("bubble.button")}</p>
            </a>
            */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LoginBubble;
